import React, { useEffect } from 'react'
import WhoWeAre from '../components/WhoWeAre/WhoWeAre'
import WhatWeDo from '../components/WhatWeDo/WhatWeDo'
import FeaturedWork from '../components/FeauturedWork/FeaturedWork'
import Testimonials from '../components/Testimonials/Testimonials'
import ContactUs from '../components/ContactUs/ContactUs'
import Hero from '../components/HeroSection/Hero'
import Reels from '../components/Reels/Reels'
import About from '../components/AboutUs/About'
import ResearchDomains from '../components/ResearchDomains'
import ResearchProcess from '../components/ResearchProcess'
import AdvisoryBoard from '../components/AdvisoryBoard'
import ResearchPublications from '../components/ResearchPublications'
import ResearchEnvironment from '../components/ResearchEnvironment'

const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the viewport
  }, []); 

  return (
    <div className='home'>
      <Hero/>
      <WhoWeAre/>
      <ResearchProcess/>
      <ResearchPublications/>
      <ResearchEnvironment/>
      <Reels/>
      <WhatWeDo/>
      <About/>
      <ResearchDomains/>
      <FeaturedWork/>
      <Testimonials/>
      <AdvisoryBoard/>
      <ContactUs/>
    </div>
  )
}

export default Home
